import Gift from "./modules/frontv2/Gift";
import GiftQuote from "./modules/frontv2/GiftQuote";
import Modal from "./modules/frontv2/Modal";
import MobileMenu from "./modules/frontv2/MobileMenu";
import MobileSearch from "./modules/frontv2/MobileSearch";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/themes/light.css";
import * as Sentry from "@sentry/browser";
import { initGlide } from "./modules/common/glide";
import { initDrops } from "./modules/common/drop";
import { initCollapsible } from "./modules/collapsible";
import { initScroll } from "./modules/scrolling";
import { initMobileMenu } from "./modules/common/mobile-menu";
import { initSelects } from "./modules/common/selects";
import { initIntlPhone } from "./modules/common/intl-phone";
import { initPhoneValidation } from './modules/phone_validation';
import { initFormValidation } from "./modules/common/form-validation";
import { initGoogleEcommerce } from "./modules/google_ecommerce";
import {
    countryPickerDelivery,
    toggleBillingAddress,
    hideExpressOnCountryChange,
    computeTotal,
} from "./modules/frontv2/PhysicalGiftCard";
import { initScrollInto } from "./modules/common/scroll-into";
import { initCommon } from "./modules/common/common";
import { initMessages } from "./modules/common/message";
import { initCorporateGiftCardGlide } from "./modules/frontv2/CorporateGift";
import { initInfoCards } from "./modules/common/info-cards";
import Lightbox from "./modules/frontv2/Lightbox";
import GiftSelect from "./modules/frontv2/GiftSelect";
import Wish from "./modules/frontv2/Wish";
import Wishlist from "./modules/frontv2/Wishlist";
import { initSwiper } from "./modules/common/init-swiper";
import { initAutocomplete } from "./modules/frontv2/Autocomplete";
import { thankYouPage } from "./modules/frontv2/thankYouPage";
import { initLinkingSeoBlock } from "./modules/frontv2/init-home-seo-block";
import { initMelchiorInput } from "./modules/common/init-melchior-input";
import { triggerConversion } from "./modules/frontv2/Checkout/checkout-utils";
import GiftPackageProduct from "./modules/frontv2/Gift/GiftPackageProduct";
import GiftPackageSearch from "./modules/frontv2/Gift/GiftPackageSearch";
import ReviewsFiltering from "./modules/frontv2/ReviewsFiltering";
import { initSeeMoreContent } from "./modules/frontv2/seeMoreContent";
import { initTabs } from "./modules/common/initTabs";

document.addEventListener("DOMContentLoaded", () => {
  // Init Sentry JS
  if (document.body.dataset.env === "prod") {
      Sentry.init({ dsn: "https://b14c92e307604f4f8f454ebdd3eab1ef@sentry.io/1441102" });
  }

  // flatpickr.localize(flatpickrLanguages[getUserLanguage()]); //TODO throws an err ?

  //common stuff
  initCommon();

  //init glides (carousels)
  initGlide();
  initCorporateGiftCardGlide();

  //Dropdowns and dropups
  initDrops();

  //Modal popups
  Modal.bindAllModals();

  //Init questions (faq) logic
  initCollapsible();

  //Header bar scroll logic
  initScroll();

  //Mobile menu
  initMobileMenu();

  //Init selects for langs (down the page)
  initSelects();

  //Flash messages
  initMessages();

  //Mobile logic
  new MobileMenu();
  new MobileSearch();

  //For phone numbers
  initIntlPhone();

  //Init form validation + recaptcha
  initFormValidation();

  //all gift logic
  new Gift();

  Wish.bindWishButtons();
  new Wishlist();

  //all gift select logic
  new GiftSelect();

  //all gift quote page logic
  new GiftQuote();

  //Analytics
  initGoogleEcommerce();

  //GIFT PAGE
  countryPickerDelivery("[name='delivery[country_id]']", {
      totalPriceContainer: ".amount",
      deliveryPriceContainer: ".amount_delivery",
      amountInput: '[name="amount"]',
      radio: '[name="amountChoice"]',
  });

  //GIFT PAGE
  toggleBillingAddress("[name='billing-different']", {
      form: "#form-billing-address",
  });

  //GIFT PAGE - BOX
  hideExpressOnCountryChange("[name='delivery[country_id]']", ".expressD", ".classicD");

  //GIFT PAGE - BOX
  computeTotal({
      giftCardAmount: "#gift-card-amount",
      subTotalContainer: "#subTotal",
      totalContainer: "#total",
      deliveryPriceContainer: "#delivery-amount",
      deliveryLabelContainer: "#delivery-label",
      amountInput: '[name="amount"]',
      radio: '[name="amountChoice"]',
      deliveryType: '[name="delivery_type"]',
  });

  initScrollInto();

  //Flash messages
  initMessages();

  const physicalMoreInfo = document.querySelector("[data-target='#more-info-physical-gift-card']");
  let physicalGlideInit = false;
  const egiftMoreInfo = document.querySelector("[data-target='#more-info-e-gift-card']");
  let egiftGlideInit = false;

  if(physicalMoreInfo){
      physicalMoreInfo.addEventListener('click', () => {
          if(!physicalGlideInit){
              window.setTimeout(() => {
                  new Lightbox("#lightBoxPhysical");
              }, 500);
              physicalGlideInit = true;
          }
      });
  }

  if(egiftMoreInfo){
      egiftMoreInfo.addEventListener('click', () => {
          if(!egiftGlideInit){
              window.setTimeout(() => {
                  new Lightbox("#lightBoxEgift");
              }, 500);
              egiftGlideInit = true;
          }
      });
  }

  tippy("[data-tippy-content]", {
      theme: "light",
  });

  initSwiper();

  initInfoCards();

  initPhoneValidation();

  initAutocomplete();

  //Function same as booking thank you page
  thankYouPage();

  //init logic for the seo black block
  initLinkingSeoBlock();

  initMelchiorInput();

  //thank you page, tracking & conversion logic
  const onThankYouPage = document.getElementById('thank-you-page');
  if(onThankYouPage){
    const triggerAnalyticsDiv = document.getElementById('trigger-analytics');
    if(triggerAnalyticsDiv){
      triggerConversion(triggerAnalyticsDiv);
    }
  }

  // Gift package landing page logic (only load maplibre where the product page exists)
  if(document.getElementById('gift-package-product')){
    if(typeof window.maplibregl === 'undefined'){
      import('maplibre-gl').then(maplibregl => {
        new GiftPackageProduct(maplibregl);
      });
    }
    else{
      new GiftPackageProduct(window.maplibregl);
    }
  }

  // logic for the gift package search page
  new GiftPackageSearch();

  // Handle AJAX Reviews Pagination (gift package page)
  new ReviewsFiltering();

  initSeeMoreContent();

  initTabs();
});
